// removed by extract-text-webpack-plugin
module.exports = {"button__primary":"src-components-Button----Button-module---button__primary---qpzlH","button__primary__reversed":"src-components-Button----Button-module---button__primary__reversed---a7wnb","button__primary__small":"src-components-Button----Button-module---button__primary__small---3O1Ch"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.scss
// module id = 855
// module chunks = 168707334958949